import { NovuNotificationType } from '@shared/enum/novu-notification-type';

export interface NovuNotificationAction {
  label: string;
  isCompleted: boolean;
}

export class NovuNotificationModel {
  private id: string;
  private subject?: string;
  private body: string;
  private createdAt: Date;
  private isRead: boolean;
  private isSeen: boolean;
  private isArchived: boolean;
  private redirectUrl?: string;
  private severity: string;
  private type?: NovuNotificationType;
  private avatar?: string;
  private primaryAction?: NovuNotificationAction;
  private secondaryAction?: NovuNotificationAction;
  private tags: string[] = [];

  private constructor() {}

  public static build(): NovuNotificationModel {
    return new NovuNotificationModel();
  }

  public withId(id: string): this {
    this.id = id;
    return this;
  }

  public withSubject(subject: string | undefined): this {
    this.subject = subject;
    return this;
  }

  public withBody(body: string): this {
    this.body = body;
    return this;
  }

  public withCreatedAt(createdAt: Date): this {
    this.createdAt = createdAt;
    return this;
  }

  public withIsRead(isRead: boolean): this {
    this.isRead = isRead;
    return this;
  }

  public withIsSeen(isSeen: boolean): this {
    this.isSeen = isSeen;
    return this;
  }

  public withIsArchived(isArchived: boolean): this {
    this.isArchived = isArchived;
    return this;
  }

  public withRedirectUrl(redirectUrl: string | undefined): this {
    this.redirectUrl = redirectUrl;
    return this;
  }

  public withSeverity(severity: string): this {
    this.severity = severity;
    return this;
  }

  public withType(type: NovuNotificationType | undefined): this {
    this.type = type;
    return this;
  }

  public withAvatar(avatar: string | undefined): this {
    this.avatar = avatar;
    return this;
  }

  public withPrimaryAction(primaryAction: NovuNotificationAction | undefined): this {
    this.primaryAction = primaryAction;
    return this;
  }

  public withSecondaryAction(secondaryAction: NovuNotificationAction | undefined): this {
    this.secondaryAction = secondaryAction;
    return this;
  }

  public withTags(tags: string[] | undefined): this {
    this.tags = tags ?? [];
    return this;
  }

  public getId(): string {
    return this.id;
  }

  public getSubject(): string | undefined {
    return this.subject;
  }

  public getBody(): string {
    return this.body;
  }

  public getCreatedAt(): Date {
    return this.createdAt;
  }

  public getIsRead(): boolean {
    return this.isRead;
  }

  public getIsSeen(): boolean {
    return this.isSeen;
  }

  public getIsArchived(): boolean {
    return this.isArchived;
  }

  public getRedirectUrl(): string | undefined {
    return this.redirectUrl;
  }

  public getSeverity(): string {
    return this.severity;
  }

  public getType(): NovuNotificationType | undefined {
    return this.type;
  }

  public getAvatar(): string | undefined {
    return this.avatar;
  }

  public getPrimaryAction(): NovuNotificationAction | undefined {
    return this.primaryAction;
  }

  public getSecondaryAction(): NovuNotificationAction | undefined {
    return this.secondaryAction;
  }

  public getTags(): string[] {
    return this.tags;
  }
}
